import { render, staticRenderFns } from "./CheckoutInsights.vue?vue&type=template&id=28ee8220&scoped=true&"
import script from "./CheckoutInsights.vue?vue&type=script&lang=js&"
export * from "./CheckoutInsights.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutInsights.vue?vue&type=style&index=0&id=28ee8220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee8220",
  null
  
)

export default component.exports